module.exports = __webpack_public_path__ + "static/media/parts.efebf82e.svg";